export const XSD_PREFIX = "http://www.w3.org/2001/XMLSchema#";
export const XSD = {
    string: XSD_PREFIX + "string",
    decimal: XSD_PREFIX + "decimal",
    integer: XSD_PREFIX + "integer",
    boolean: XSD_PREFIX + "boolean",
    date: XSD_PREFIX + "date",
    time: XSD_PREFIX + "time",
    dateTimeStamp: XSD_PREFIX + "dateTimeStamp",
    dateTime: XSD_PREFIX + "dateTime",
    anyURI: XSD_PREFIX + "anyURI",
};
//# sourceMappingURL=xsd.js.map